import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { EducationtestconfigComponent } from './education-testconfig.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


const routes: Routes = [{
	path: '',
	data: {
      title: 'Education: Class Configuration',
      urls: [{title: 'Dashboard',url: '/'},{title: 'Education: Class Configuration'}]
    },
	component: EducationtestconfigComponent
}];

@NgModule({
	imports: [
    	FormsModule,
    	CommonModule, 
		NgbModule.forRoot(),
    	RouterModule.forChild(routes)
    ],
	declarations: [EducationtestconfigComponent]
})
export class EducationtestconfigModule { }


// WEBPACK FOOTER //
// /Users/sheashay/Sites/ihsaa-ams-design/src/app/pages/education/education-testconfig/education-testconfig.module.ts